import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { ParametersService } from '@app/components/parameters/parameters.service';
import { User } from '@app/components/user/user';
import { UserManagerService } from '@app/managers';
import { filter } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { toSignal } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-launcher',
    templateUrl: './launcher.component.html',
    styleUrls: ['./launcher.component.scss'],
    standalone: false
})

export class LauncherComponent implements OnInit {
    env = environment; // hack to make env template accessible
    user: User;
    locale: string = '';
    alertMessage: string = '';
    isAlertOpen: boolean = false;
    isLoggedIn: boolean = false;
    isAuthenticated = toSignal(this.authService.isAuthenticated$, { initialValue: false });
    constructor(
        private readonly router: Router,
        private readonly parametersService: ParametersService,
        private readonly userManagerService: UserManagerService,
        private readonly authService: AuthService,
        private readonly http: HttpClient,
        private readonly deviceService: DeviceDetectorService
    ) {
    }

    ngOnInit(): void {
        if (this.isAuthenticated()) {
            this.isLoggedIn = true;
            this.userManagerService.getUser();
            this.parametersService.getParametersObservable()
                .subscribe(x => {
                    this.user = x.user;
                    if (x.user?.locale) {
                        this.locale = x.user.locale;
                    }
                });

            if (this.router.url.includes('logout')) {
                this.isAlertOpen = true;
                this.alertMessage = 'YouHaveBeenSignedOut';
            }
        } else {
            this.parametersService.getParametersObservable().pipe(
                filter(x => !!x?.country)
            ).subscribe(x => {
                this.locale = x.country.code;
            });
        }
    }

    closeAlert() {
        this.isAlertOpen = !this.isAlertOpen;
    }

    onClickNewsletter(): void {
        if (this.isLoggedIn) {
            this.router.navigate(['/profile-overview']);
        } else {
            const url = `https://www.poettinger.at/${this.locale}/newsroom/newsletter`;
            const win = window.open(url, '_blank');
            win.focus();
        }
    }

    navigateToFanshop(): void {
        this.trackFanshopNavigation();
        window.location.href = 'https://fanshop.mypoettinger.com/';
    }

    trackFanshopNavigation(): void {
        this.http.post(`${environment.apiPath}/fanshop/views/open`, {
            locale: this.locale,
            platform: this.deviceService.deviceType
        }).subscribe();
    }
}
